import { action, observable, reaction, makeObservable } from 'mobx';
import {User, VersionedContentLookup, contentLookupService, ContentLookup, SuccessResponse,X1Language, X2AgeCategory, X2AgeCategoryUpdateModel} from '../../../domain';
import {Disposers, HttpPromiseState, PromiseState,Control, validators} from '../../../lib/helpers';
import { ClassroomLoaders } from '../stores/classroom-loaders';


export class TeacherStudentsSceneStore {
  
  @observable.ref
  resultState: HttpPromiseState<User[]> | null = null;

  @observable.ref
  lookupState: PromiseState<VersionedContentLookup> | null;
  private readonly disposers = new Disposers();

  constructor() {
      makeObservable(this);      
      this.resultState = null;
      this.lookupState = contentLookupService.load();
      this.setup();
    }  

  loadResults = () => {
    if (this.resultState?.isPending === true)
      return;
      
    this.resultState = ClassroomLoaders.Teacher.getTeacherStudents();
  };

  private setup() {
    this.loadResults();
  } 

  @action
  loadLookup = () => {
    if (this.lookupState?.isPending === true)
      return;
    this.lookupState = contentLookupService.load();
  };
  dispose = () => {
    this.disposers.dispose();
  };
}
